import Image from 'next/image';
import {defaultThemeImagePaths, priceHelper} from '@helpers/config-master.mjs';
import {ProductCardDesktop} from '@components/product/desktop/ProductCardDesktop';
import {JsonLdBreadcrumbList} from '@components/json-ld/breadcrumb-list';
import {CollectionHeaderDesktop} from '@components/collections/CollectionPageDesktop';

export const CollectionProductsPageDesktop = ({
  slug,
  category,
  title,
  description,
  products,
  session
}) => {
  return (
    <>
      <CollectionProductsDesktop
        products={products}
        title={title}
        description={description}
        session={session}
      />
      <JsonLdBreadcrumbList
        handle={'/collections/' + category?.handle}
        title={category?.category}
        handle2={'/collections/' + slug}
        title2={title}
      />
      {/*<GlobalExecute execute={() => viewCollectionPageEvent(slug, title, products)}/>*/}
    </>
  );
};

export const CollectionProductsDesktop = ({products, title, description, session}) => {
  // console.log("[CollectionProductsDesktop] products:", products);
  const isDealer = session?.user?.isDealer ?? session?.is_dealer;

  const saleIsEnabled = priceHelper.saleEnabled === true;
  const isSourceCollectionPage = true;

  // const desktopHeaderImage = useDesktopCollectionHeaderImage();
  // const desktopProductImageSaleOverlay = useDesktopProductImageSaleOverlay();

  const desktopHeaderImage = defaultThemeImagePaths?.desktopCollectionPageHeaderImage;
  const desktopProductImageSaleOverlay = defaultThemeImagePaths?.desktopProductImageSaleOverlay;

  return (
    <>
      {saleIsEnabled && (
        <div className="m-auto pb-3">
          {desktopHeaderImage && (
            <Image
              src={desktopHeaderImage}
              alt="desktop banner"
              width="1200"
              height="185"
              loading="eager"
            />
          )}
        </div>
      )}

      <CollectionHeaderDesktop title={title} description={description} />

      <div className="pt-5">
        <p className="text-sm text-gray-500 mt-5 mb-5 hidden">
          {products?.length} {products?.length > 1 ? 'products' : 'product'}
        </p>
        <div className="grid grid-cols-3 gap-8 mb-16">
          {products?.map((product, index) => {
            const key = product?.sku ?? product?.slug ?? index;
            return (
              <div id="product-card-container" key={key}>
                <ProductCardDesktop
                  product={product}
                  isSourceCollectionPage={isSourceCollectionPage}
                  desktopProductImageSaleOverlay={desktopProductImageSaleOverlay}
                  isDealer={isDealer}
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
